export default __webpack_public_path__ + "static/media/icon_price_zero.1e827443.svg";